import React from "react";
import { Award, Truck, RotateCcw, ArrowLeftRight } from "lucide-react";
import { SectionHeading } from "@/pages/home/SectionHeading";

const PROMISE_ICONS = [Award, Truck, RotateCcw, ArrowLeftRight];

export const OurPromiseSection = ({ promises }) => (
  <section className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 pt-16">
    <SectionHeading>Our Promise</SectionHeading>
    <div className="grid grid-cols-2 sm:grid-cols-4 gap-x-4 gap-y-8 mt-2">
      {promises.map((f, i) => {
        const Icon = PROMISE_ICONS[i % PROMISE_ICONS.length];
        return (
          <div key={f.title || `promise-${i}`} className="flex flex-col items-center text-center gap-3">
            <Icon strokeWidth={1.1} className="h-10 w-10 text-[hsl(var(--primary))]" />
            <div className="text-xs sm:text-sm text-foreground/80 leading-snug max-w-[140px]">{f.title}</div>
          </div>
        );
      })}
    </div>
  </section>
);
